import { useStore } from "../store";

export const useCheckout = () => {
    const [state] = useStore()
    const { checkout } = state
    return checkout
}

export default useCheckout